<div class="c-sticky-footer-bar" *ngIf="showStickyFooterBar">
  <div class="c-sticky-footer-bar__wrapper">
    <rl-list-status-panel
      *ngIf="isEditMode"
      [list]="list"
      [editableList]="editableList"
      [permissions]="permissions"
      [listPublishingStatus]="listPublishingStatus"
      [queueSize]="queueSize"
    ></rl-list-status-panel>

    <div class="c-sticky-footer-bar__buttons">
      <button
        type="button"
        (click)="scrollToTop()"
        class="btn btn-default qa-back-to-top"
      >
        <i class="fas fa-arrow-up" aria-hidden="true"></i>
        <ng-container i18n="@@stickyFooterBar-button-backToTop"
          >Back to top</ng-container
        >
      </button>

      <button
        *ngIf="showRequestReviewButton"
        (click)="requestReview()"
        type="button"
        class="btn btn-primary qa-request-review"
        i18n="@@stickyFooterBar-button-requestReview"
      >
        Request review
      </button>

      <button
        *ngIf="showReviewAndPublishButton"
        (click)="reviewAndPublish()"
        type="button"
        class="btn btn-default qa-review-and-publish"
        i18n="@@stickyFooterBar-button-reviewAndPublish"
      >
        Review & Publish
      </button>

      <button
        *ngIf="showPublishButton"
        type="button"
        class="btn btn-primary qa-publish"
        i18n="@@stickyFooterBar-button-publish"
        (click)="publish()"
      >
        Publish
      </button>
    </div>
  </div>
</div>
